import * as THREE from 'three';
import { BehaviorSubject } from 'rxjs';

// Créer des sujets observables pour la progression et l'état de chargement
export const loadingProgress = new BehaviorSubject<number>(0);
export const isLoading = new BehaviorSubject<boolean>(false);

const manager = new THREE.LoadingManager();
let startTime: number;

// Callback appelé au démarrage du chargement du premier fichier
manager.onStart = (url: string, itemsLoaded: number, itemsTotal: number): void => {
	startTime = performance.now();
	isLoading.next(true);
	loadingProgress.next(0);
	// console.log(`Début du chargement: ${url} (${itemsLoaded} sur ${itemsTotal})`);
};

// Callback appelé pendant le chargement
manager.onProgress = (url: string, itemsLoaded: number, itemsTotal: number): void => {
	const progress: number = (itemsLoaded / itemsTotal) * 100;
	loadingProgress.next(progress);
	// console.log(`Progression: ${progress.toFixed(2)}% (${itemsLoaded}/${itemsTotal})`);
};

// Callback appelé lorsque tous les fichiers sont chargés
manager.onLoad = (): void => {
	const endTime: number = performance.now();
	// console.log(`Tous les fichiers ont été chargés en ${endTime - startTime} ms.`);
	isLoading.next(false);
	loadingProgress.next(100);
};

// Callback en cas d'erreur
manager.onError = (url: string): void => {
	console.error(`Erreur de chargement du fichier: ${url}`);
};

export { manager };
